import { initialState } from "./index";
import { createSelector } from "@reduxjs/toolkit";

const selectMarketplaceState = (state) => state.marketplace || initialState;

export const selectMarketplace = createSelector(
  [selectMarketplaceState],
  (marketplaceState) => marketplaceState.marketplace
);

export const selectMarketplaceDropdown = createSelector(
  [selectMarketplaceState],
  (marketplaceState) => marketplaceState.marketplace?.dropdownOptions
);

export const selectSelectedMarketplace = createSelector(
  [selectMarketplaceState],
  (marketplaceState) => marketplaceState.marketplace.selectedMarketplace
);

export const selectMarketplaceUser = createSelector(
  [selectMarketplaceState],
  (marketplaceState) => marketplaceState.marketplaceUser
);

export const selectCreateMarketplaceCampaign = createSelector(
  [selectMarketplaceState],
  (marketplaceState) => marketplaceState.createCampaign
);

export const selectCampaignReport = createSelector(
  [selectMarketplaceState],
  (marketplaceState) => marketplaceState.campaignReport
);

export const selectPosterCounts = createSelector(
  [selectMarketplaceState],
  (marketplaceState) => marketplaceState.campaignReport.poster_counts
);

export const selectMarketplaceApproval = createSelector(
  [selectMarketplaceState],
  (state) => state.marketplaceApproval
);
